// Section palette — mirrors MonthProjection so the visual language stays
// consistent between pay-period and monthly forecasts.
// - `bg`      : the darker/saturated shade for the section HEADER row
// - `subBg`   : a lighter wash of the same hue for the subrows below it
// Two-tier shading makes the header/subrow relationship obvious at a glance.
export const SECTION = {
  bank: {
    bg: "bg-[#E8E4DC]",
    subBg: "bg-[#F5F1EA]",
    border: "border-[#CDC7BB]",
    label: "text-[#3E4340]",
    amount: "text-[#2C302E]",
    accent: "bg-[#4A6148]",
    header: "Step 1 · Bank & Cash",
    subheader: "Update your current bank + cash balances",
  },
  bills: {
    bg: "bg-[#F5D9D1]",
    subBg: "bg-[#FBEEEA]",
    border: "border-[#E5B4A3]",
    label: "text-[#7A2E24]",
    amount: "text-[#7A2E24]",
    accent: "bg-[#7A2E24]",
    header: "Step 2 · Your Bills & Planned Purchases",
    // Desktop title adds "Your" for a warmer, personalised read; mobile
    // trims it to save the ~40px so the title doesn't wrap on narrow
    // screens. Rendering hookup lives in Rows.jsx (SectionHeader).
    mobileHeader: "Step 2 · Bills & Planned Purchases",
    subheader: "Bills and one-off planned purchases due in this pay period",
  },
  incoming: {
    bg: "bg-[#DDE9D8]",
    subBg: "bg-[#EEF4EC]",
    border: "border-[#B8CFB1]",
    label: "text-[#2F4E32]",
    amount: "text-[#2F4E32]",
    accent: "bg-[#2F4E32]",
    header: "Step 3 · Money Coming In",
    subheader: "Confirm expected paychecks",
  },
  final: {
    bg: "bg-[#FCE3C6]",
    border: "border-[#2C302E]",
    label: "text-[#7A4E1F]",
    accent: "bg-[#7A4E1F]",
    header: "Remaining Balance for Other Expenses",
  },
};
